import { render } from "./CustomNode.vue?vue&type=template&id=b965d7ae&scoped=true&ts=true"
import script from "./CustomNode.vue?vue&type=script&lang=ts"
export * from "./CustomNode.vue?vue&type=script&lang=ts"

import "./CustomNode.vue?vue&type=style&index=0&id=b965d7ae&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b965d7ae"]])

export default __exports__